import * as yup from 'yup';
import i18n from '../../../../localization/i18n';
import {
    LABEL_FIELD_ERROR_INVALID_EMAIL,
    LABEL_FIELD_ERROR_REQUIRED,
} from '../../../../localization/resouceKeys';

export const loginValidations = yup.object().shape({
    email: yup
        .string()
        .required(() => i18n.t(LABEL_FIELD_ERROR_REQUIRED))
        .email(() => i18n.t(LABEL_FIELD_ERROR_INVALID_EMAIL))
        // eslint-disable-next-line max-len
        .matches(
            // eslint-disable-next-line max-len
            /^([a-zA-Z0-9_\u00C0-\u024F\-.]+)@([a-zA-Z0-9_\u00C0-\u024F\-.]+)\.([a-zA-Z\u00C0-\u024F]{2,63})$/i,
            () => i18n.t(LABEL_FIELD_ERROR_INVALID_EMAIL),
        ),
    password: yup.string().required(() => i18n.t(LABEL_FIELD_ERROR_REQUIRED)),
});
